import AutoSuggest from 'components/Select/AutoSuggestSync'
import Style from 'components/Style'
import { Tag, Tags } from 'components/Tags'
import * as React from 'react'
import { connect } from 'react-redux'

import { City } from '../../data/models/funnelOrder/cities'
import { destinationEnum } from '../../data/models/funnelOrder/destination'
import {
  filterDestination,
  getMaxIncludedCities,
} from '../../data/models/funnelOrder/includedCities'
import { Theme } from '../../data/models/funnelOrder/theme'
import { PerCountry, SiteCountry } from '../../data/models/locale'
import { AppState } from '../../data/state'
import * as actions from '../../store/actions'
import { IncludeCitiesOptions } from '../../store/funnelOrder/themeCities/types'

interface FlyIncludedCitiesStateProps {
  theme: Theme
  country: SiteCountry
  themeCities: IncludeCitiesOptions[]
}

export interface FlyIncludedCitiesDispatchProps {
  getThemeCities: () => void
}

export interface FlyIncludedCitiesOwnProps {
  includedCities: City[]
  destination: destinationEnum
  max?: number
  solid?: boolean
  setIncludedCities(value: City[]): void
}

export interface FlyIncludedCitiesProps
  extends FlyIncludedCitiesStateProps,
    FlyIncludedCitiesDispatchProps,
    FlyIncludedCitiesOwnProps {}

class FlyIncludedCities extends React.Component<FlyIncludedCitiesProps> {
  public componentDidMount() {
    this.props.getThemeCities()
  }

  public render() {
    const {
      themeCities,
      destination,
      includedCities,
      theme,
      country,
      solid,
    } = this.props
    const max = this.getMaxCityItems()

    const filtered = filterDestination(
      includedCities,
      theme,
      destination || destinationEnum.allOfEurope,
      max,
    )

    const placeholder: PerCountry<string> = {
      [SiteCountry.nl]: 'Geef een stad op',
      [SiteCountry.be]: 'Geef een stad op',
      [SiteCountry.uk]: 'Add a city',
      [SiteCountry.ie]: 'Add a city',
      [SiteCountry.dk]: 'Tilføj en storby',
    }

    const searchPromptText: PerCountry<string> = {
      [SiteCountry.nl]: 'Type om te zoeken',
      [SiteCountry.be]: 'Type om te zoeken',
      [SiteCountry.uk]: 'Type to search',
      [SiteCountry.ie]: 'Type to search',
      [SiteCountry.dk]: 'Søg',
    }

    return (
      <>
        {includedCities.length >= max ? null : (
          <Style margin={[[0, 0, 20, 0]]}>
            <AutoSuggest
              options={themeCities}
              onChange={this.addTag}
              placeholder={placeholder[country]}
              searchPromptText={searchPromptText[country]}
            />
          </Style>
        )}

        <Tags solid={solid}>
          {filtered.map((value, i) => (
            <Tag
              key={i}
              text={value.name}
              onDelete={() => this.deleteTag(value.id)}
            />
          ))}
          {includedCities.map((value, i) => {
            if (!filtered.includes(value)) {
              return (
                <Tag
                  key={i}
                  text={value.name}
                  strikeThrough
                  onDelete={() => this.deleteTag(value.id)}
                />
              )
            }
          })}
        </Tags>
      </>
    )
  }

  private isCityIncluded = (cityValue: City) => {
    const { includedCities } = this.props
    return includedCities.some(c => c.id === cityValue.id)
  }

  private addTag = (value: any): void => {
    const { includedCities } = this.props
    if (value) {
      const max = this.getMaxCityItems()
      const cityValue: City = {
        id: +value.value!,
        name: value.label,
        direction: value.direction,
      }
      if (!this.isCityIncluded(cityValue)) {
        const allIncludedCities = [...includedCities, cityValue].slice(0, max)
        this.props.setIncludedCities(allIncludedCities)
      }
    }
  }

  private getMaxCityItems = () => {
    const { max } = this.props
    return max || getMaxIncludedCities()
  }

  private deleteTag = (id: number) => {
    const { includedCities } = this.props
    const allIncludedCities = includedCities.filter(city => city.id !== id)
    this.props.setIncludedCities(allIncludedCities)
  }
}

export default connect<
  FlyIncludedCitiesStateProps,
  FlyIncludedCitiesDispatchProps,
  FlyIncludedCitiesOwnProps,
  AppState
>(
  state => ({
    theme: state.funnelOrder.theme,
    country: state.locale.country,
    themeCities: state.funnelOrder.themeCities.data,
  }),
  dispatch => ({
    getThemeCities: () => dispatch(actions.funnelOrderThemeCitiesGetRequest()),
  }),
)(FlyIncludedCities)
